import api from './api';

export const obtenerConfiguracion = async () => {
  const response = await api.get('/configuracion');
  return response.data;
};

export const obtenerConfiguracionPorClave = async (clave) => {
  const response = await api.get(`/configuracion/${clave}`);
  return response.data;
};

export const actualizarConfiguracion = async (clave, valor) => {
  const response = await api.put(`/configuracion/${clave}`, {
    Valor: valor
  });

  return response.data;
};

export const obtenerDiasParaPendiente = async () => {
  try {
    const data = await obtenerConfiguracionPorClave('DiasParaPendiente');
    const valor = Number(data.Valor);

    if (!Number.isInteger(valor) || valor < 1) {
      return 3;
    }

    return valor;
  } catch (error) {
    return 3;
  }
};